import React from "react";
import { Link, useLocation } from "react-router-dom";
import MerchantPageShell from "../../components/merchant/MerchantPageShell";

export default function VerifyEmailSent({ accountType = "shopper" }) {
  const location = useLocation();
  const email = location.state?.email || "";

  const isMerchant = accountType === "merchant";

  return (
    <MerchantPageShell
      eyebrow={isMerchant ? "Merchant Account" : "Shopper Account"}
      title="Check your email"
      lede="We’ve sent you a verification link. Click it to finish creating your account."
    >
      <div className="merchant-form">
        <p
          style={{
            margin: 0,
            color: "rgba(43, 43, 43, 0.78)",
            lineHeight: 1.6,
          }}
        >
          {email ? (
            <>
              We sent the link to <strong>{email}</strong>.
            </>
          ) : (
            "The verification link has been sent to the email address you used to sign up."
          )}
        </p>

        <p
          style={{
            margin: 0,
            color: "rgba(43, 43, 43, 0.72)",
            lineHeight: 1.6,
            fontSize: 14,
          }}
        >
          The link expires after 24 hours. If it doesn’t arrive, check your spam or promotions folder.
        </p>

        <div className="merchant-actions">
          <Link
            className="gold-btn"
            to={isMerchant ? "/merchant/login" : "/login"}
            style={{ textDecoration: "none" }}
          >
            Go to login
          </Link>
        </div>
      </div>
    </MerchantPageShell>
  );
}